import { Image as ImageIcon, PictureAsPdf as PdfIcon, SvgIconComponent } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material/SvgIcon";
import DocumentIcon from "icons/Documents.svg";

export default function FileIcon({ mimeType, ...rest }: { mimeType?: string } & SvgIconProps) {
  let Icon: SvgIconComponent | React.FunctionComponent<React.SVGProps<SVGSVGElement>> = DocumentIcon;

  if (mimeType === "application/pdf") {
    Icon = PdfIcon;
  } else if (mimeType && mimeType.startsWith("image")) {
    Icon = ImageIcon;
  }

  return <Icon {...rest} />;
}
